// Auto-discovering data aggregator
import { users, getUserById } from './users';
import { Topic, Post, Category } from '../types/forum';

// Import all category data
import * as newcomersCategory from './categories/newcomers';
import * as sightingsCategory from './categories/sightings';
import * as searchPartyCategory from './categories/search-party';

// Auto-generate categories from imported category data
export const categories: Category[] = [
  {
    id: newcomersCategory.categoryId,
    name: newcomersCategory.categoryName,
    description: newcomersCategory.categoryDescription,
    order: 1,
    topicCount: newcomersCategory.topics.length,
    postCount: newcomersCategory.posts.length
  },
  {
    id: sightingsCategory.categoryId,
    name: sightingsCategory.categoryName,
    description: sightingsCategory.categoryDescription,
    order: 2,
    topicCount: sightingsCategory.topics.length,
    postCount: sightingsCategory.posts.length
  },
  {
    id: searchPartyCategory.categoryId,
    name: searchPartyCategory.categoryName,
    description: searchPartyCategory.categoryDescription,
    order: 3,
    topicCount: searchPartyCategory.topics.length,
    postCount: searchPartyCategory.posts.length
  }
];

// Auto-aggregate all topics and posts
export const topics: Topic[] = [
  ...newcomersCategory.topics,
  ...sightingsCategory.topics,
  ...searchPartyCategory.topics
];

export const posts: Post[] = [
  ...newcomersCategory.posts,
  ...sightingsCategory.posts,
  ...searchPartyCategory.posts
];

// Export everything for backward compatibility
export const mockUsers = users;
export const mockCategories = categories;
export const mockTopics = topics;
export const mockPosts = posts;

// Helper functions
export const getCategoryById = (id: string): Category | undefined => {
  return categories.find(category => category.id === id);
};

export const getTopicById = (id: string): Topic | undefined => {
  return topics.find(topic => topic.id === id);
};

export const getPostsByTopicId = (topicId: string): Post[] => {
  return posts.filter(post => post.topicId === topicId);
};

// Utility function to add new topics to a category
export const addTopicToCategory = (
  categoryId: string, 
  topic: Omit<Topic, 'id'>, 
  post: Omit<Post, 'id' | 'topicId'>
) => {
  // This would be used for dynamic topic creation
  // For now, we'll keep the static structure
  console.log('Topic creation would be handled here');
}; 